'use client';

const STEPS = [
  { num: '01', label: 'TYPE' },
  { num: '02', label: 'WHEN' },
  { num: '03', label: 'DETAILS' },
] as const;

export function BookingStepper({ step }: { step: 1 | 2 | 3 }) {
  const progress = ((step - 1) / 2) * 100;
  return (
    <div className="w-full max-w-[680px] mx-auto">
      <div className="hidden md:flex items-center gap-3">
        {STEPS.map((s, i) => {
          const idx = i + 1;
          const completed = idx < step;
          const active = idx === step;
          return (
            <div key={s.num} className="flex items-center gap-3 flex-1 last:flex-none">
              <div
                className="flex items-center gap-2.5"
                style={{
                  color: completed
                    ? 'var(--accent)'
                    : active
                    ? 'var(--text-primary)'
                    : 'var(--text-caption)',
                }}
              >
                <span
                  className="font-mono inline-flex items-center justify-center"
                  style={{
                    width: 28,
                    height: 28,
                    borderRadius: '50%',
                    fontSize: 11,
                    fontWeight: 800,
                    letterSpacing: '0.04em',
                    background: active
                      ? 'linear-gradient(135deg, var(--accent), var(--indigo))'
                      : completed
                      ? 'rgba(212,165,116,0.12)'
                      : 'transparent',
                    color: active
                      ? 'var(--bg-primary)'
                      : completed
                      ? 'var(--accent)'
                      : 'var(--text-caption)',
                    border: active
                      ? '1px solid transparent'
                      : completed
                      ? '1px solid var(--accent-mid)'
                      : '1px solid var(--border)',
                  }}
                >
                  {completed ? (
                    <svg width="13" height="13" viewBox="0 0 12 12" fill="none" aria-hidden="true">
                      <path
                        d="M2 6l3 3 5-5"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  ) : (
                    s.num
                  )}
                </span>
                <span
                  className="font-mono"
                  style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.14em' }}
                >
                  {s.label}
                </span>
              </div>
              {idx < STEPS.length && (
                <div
                  className="flex-1"
                  style={{
                    height: 1,
                    background: 'var(--border)',
                    position: 'relative',
                    overflow: 'hidden',
                  }}
                >
                  <span
                    aria-hidden
                    style={{
                      position: 'absolute',
                      inset: 0,
                      width: idx < step ? '100%' : '0%',
                      background: 'linear-gradient(90deg, var(--accent), var(--indigo))',
                      transition: 'width 600ms cubic-bezier(0.16, 1, 0.3, 1)',
                    }}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Mobile */}
      <div className="md:hidden flex flex-col gap-2">
        <div className="flex items-center justify-between">
          <span
            className="font-mono text-text-muted"
            style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.14em' }}
          >
            STEP {step} OF 3 · {STEPS[step - 1].label}
          </span>
          <span className="font-mono text-text-caption" style={{ fontSize: 10 }}>
            {Math.round(progress)}%
          </span>
        </div>
        <div
          style={{
            height: 2,
            background: 'var(--border)',
            borderRadius: 999,
            overflow: 'hidden',
            position: 'relative',
          }}
        >
          <span
            aria-hidden
            style={{
              position: 'absolute',
              inset: 0,
              width: `${progress}%`,
              background: 'linear-gradient(90deg, var(--accent), var(--indigo))',
              transition: 'width 600ms cubic-bezier(0.16, 1, 0.3, 1)',
            }}
          />
        </div>
      </div>
    </div>
  );
}
